export default function Logo({ variant = "dark", compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <img
        src={variant === "light" ? "/tk-logo-white.png" : "/tk-logo-dark.png"}
        alt="Thom Kriner LLC mark"
        className="h-11 w-auto"
      />
      {!compact && (
        <span className="leading-none">
          <span className="block font-display text-lg font-semibold tracking-tight text-current">
            Thom Kriner <span className="font-medium text-[#8B95A5]">LLC</span>
          </span>
          <span className="mt-1 block font-mono text-[10px] tracking-[0.35em] text-[#8B95A5]">
            MANAGEMENT CONSULTING
          </span>
        </span>
      )}
    </span>
  );
}
